import { defineStore } from 'pinia'
import { markRaw } from 'vue'

// The one question the confirm dialog (ConfirmHost, in App) shows, and
// how to answer it. See services/confirm.
export const useConfirmStore = defineStore('confirm', {
  state: () => ({
    // { title, text, confirmText, cancelText, danger, resolve }
    question: null,
  }),
  actions: {
    ask(question) {
      // one at a time: an open question is taken as no
      this.question?.resolve(false)
      return new Promise((resolve) => {
        this.question = { ...question, resolve: markRaw(resolve) }
      })
    },
    answer(yes) {
      const question = this.question
      this.question = null
      question?.resolve(yes)
    },
  },
})
